import HospitalUserDTO from '@src/adapters/dto/hospital/HospitalUserDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  isActive: boolean;
  userId: string;
  hospitalId: string;
}

type Result = HospitalUserDTO[];

const options: ApiOptions = {
  method: 'patch',
  urlPath: '/hospital/user/setActive',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useToggleHospitalUserLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useToggleHospitalUserLazy;
